<template>
  <combobox
    v-model="selectedOffsets"
    :items="items"
    :is-multiple="true"
    class="mt-0! phone:flex-wrap!"
  />
</template>

<script setup lang="ts">
import { WuiCombobox, type SelectItem } from '@wui/common-library'
import { storeToRefs } from 'pinia'
import { type Component, computed } from 'vue'

import { useStoreSettingsNotifications } from '@/entities/notification'

import { useLocalization } from '@/shared/composables/localization'
import {
  ScheduleReminderOffset,
  type ScheduleReminderOffsetValue,
} from '@/shared/types/notification'

const Combobox = WuiCombobox as Component

const { scheduleReminderOffsets } = storeToRefs(useStoreSettingsNotifications())
const { t } = useLocalization()

const items = computed<SelectItem<ScheduleReminderOffsetValue>[]>(() => [
  {
    label: t('notifications.scheduleReminderOffset5Minutes'),
    value: ScheduleReminderOffset.FIVE_MINUTES,
  },
  {
    label: t('notifications.scheduleReminderOffset1Hour'),
    value: ScheduleReminderOffset.ONE_HOUR,
  },
])

const selectedOffsets = computed({
  get: (): ScheduleReminderOffsetValue[] => scheduleReminderOffsets.value,
  set: (value: ScheduleReminderOffsetValue[]) => {
    scheduleReminderOffsets.value = value
  },
})
</script>
